export default "__VITE_ASSET__shuH84Zu__"